import React from 'react';
import { Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Block from '../../../Block';
import DualAxisColumnChart from '../../../charts/DualAxisColumnChart';
import { useGetPublisherAdminLocationStatusQuery } from '../../../../api/publisherAdminApiSlice';

const MAUByLocationsStatus = ({publisherId, ...props}) => {
  const { t } = useTranslation();
  const {data = [], isSuccess, isLoading, isError, retry} = useGetPublisherAdminLocationStatusQuery(publisherId)
  const categories = data.map((x) => (x.location_status))
  const mau = data.map((x) => (x.locations_uu_30_days))
  const consent_rate = data.map((x) => (100 * x.locations_uu_30_days / x.consented_devices ))

  return (
    <Block  title={t('publisher.maus_by_location_status')} {...props}>
      <DualAxisColumnChart data={
          {
            "categories": categories,
            "series": [
              {
                "name": "MAU",
                "data": mau
              },
              {
                "name": "% of consented devices",
                "data": consent_rate
              }
            ]
          }
        }/>
    </Block>
  )
}

export default MAUByLocationsStatus
